var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "62px",
    viewBox: "0 0 124 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MVV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-Home",
    transform: "translate(-32.000000, -3216.000000)",
    fill: "#F2D4B6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVV",
    transform: "translate(32.000000, 3216.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "3.94573448e-15 61.6692591 5.82189898 61.6692591 5.82189898 -0.00155487573 3.94573448e-15 -0.00155487573"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "117.819598 61.6692591 123.641497 61.6692591 123.641497 -0.00155487573 117.819598 -0.00155487573"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "25.3120441 61.6701476 17.3799567 -0.000666375313 11.5069689 -0.000666375313 19.4390564 61.6701476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "44.9778902 61.6701476 28.8427227 -0.000666375313 22.8253536 -0.000666375313 38.9582999 61.6701476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "64.9778125 61.6701476 40.0598183 -0.000666375313 33.7825629 -0.000666375313 58.6983358 61.6701476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "64.943161 61.6701476 89.858934 -0.000666375313 83.5816785 -0.000666375313 58.6636843 61.6701476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "84.6827526 61.6701476 100.815699 -0.000666375313 94.7983299 -0.000666375313 78.6631623 61.6701476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "104.198886 61.6701476 112.133195 -0.000666375313 106.262429 -0.000666375313 98.3281199 61.6701476"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.401374cff5a618d8dcfe0ea7503bddad.svg";
export { ForwardRef as ReactComponent };